import React, { Component } from 'react';

import Navbar from './Navbar';

class Sidebar extends Component {
    render() {
        return (
            <aside className="app-sidebar">
                <div className="aside-inner">
                    <Navbar />
                </div>
            </aside>
        );
    }
}

export default Sidebar;